import React, { Fragment, Component } from 'react';
import classnames from "classnames";
import Breadcrumb from '../common/breadcrumb';
import IntlTelInput from "react-intl-tel-input";
import { libphonenumber } from "react-intl-tel-input/dist/libphonenumber.js";
import "react-intl-tel-input/dist/main.css";
import { AvFeedback, AvField, AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";
import { toast, ToastContainer } from "react-toastify";
import { Button, Card, CardBody, CardFooter, CardHeader, PopoverHeader } from "reactstrap";
import jwt_decode from "jwt-decode";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import Select from "react-select";
import ImageUploader from 'react-images-upload';
// import "react-select/dist/react-select.css";
import user from '../../assets/images/user/user.png';
import admin_heading from "../../images/candidate/admin-heading.svg";
import moment from "moment";
import request, { NodeURL } from "../../api/api"
import Avatar from "react-avatar-edit";
import CandidateStats from "../dashboard/stats";
import { Col, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane, Popover, PopoverBody, CustomInput, Table } from "reactstrap";

class EDITPROFILE extends Component {
    state = {
        username: "",
        password: "",
        confirm_password: "",
        name: "",
        email: "",
        status: "",
        role: "",
        code: "",
        job_type: "",
        employee_rate: "",
        client_rate: "",
        number: "",
        dailcountry: "gb",
        address: "",
        line1: "",
        line2: "",
        city: "",
        state: "",
        country: "",
        zipcode: "",
        formatted_address: "",
        avatar: "",
        phoneerror: false,
        phonestatus: "",
        avatar_return: "",
        jobtypelist: [],
        activeTab: "1",
        availableactiveTab: "1",
        unavailableactiveTab: "1",
        activemodeledittab: "1",
        // holiday_allowance: "",
        joining_date: null,
        final_date: null,
        timelist: [],
        sunstarttime: "",
        sunendtime: "",
        sunavailablestatus: 0,
        monstarttime: "",
        monendtime: "",
        monavailablestatus: 0,
        tuestarttime: "",
        tueendtime: "",
        tueavailablestatus: 0,
        wedstarttime: "",
        wedendtime: "",
        wedavailablestatus: 0,
        thustarttime: "",
        thuendtime: "",
        thuavailablestatus: 0,
        fristarttime: "",
        friendtime: "",
        friavailablestatus: 0,
        satstarttime: "",
        satendtime: "",
        satavailablestatus: 0,
        unavaiablestarttime: "",
        unavaiableendtime: "",
        unavailablestatus: 0,
        from: "",
        to: "",
        unavailabledate: "",
        worklist: [],
        locations: "",
        timeoffdata: [],
        dates: [],
        int: false
    };

    componentDidMount() {
        const tokens = localStorage.getItem("APUSEC");
        let token;
        if (tokens) {
            token = jwt_decode(tokens);
        }
        this.call_timer1 = setInterval(() => { this.setState({ int: false }); }, 1500000);
        this.call_timer2 = setInterval(() => { this.setState({ int: true }); }, 1800000);
        request({
            url: "/employee/agencydetails",
            method: "POST"
        }).then(res => {
            if (res.status === 1) {
                this.setState({
                    worklist: res.response.result[0].locations || {},
                    jobtypelist: res.response.result[0].jobtypes || {}
                });
                const worklist = this.state.worklist.map((emp, key) => ({
                    value: emp._id,
                    label: emp.name
                }));
                const jobtypelist = this.state.jobtypelist.map((emp, key) => ({
                    value: emp._id,
                    label: emp.name
                }));
                this.setState({
                    worklist,
                    jobtypelist
                });
            } else if (res.status === 0) {
                let toastId = "jobtypelistResponse";
                if (!toast.isActive(toastId)) {
                    toastId = toast.error(res.response);
                }
            }
        });
        request({
            url: "/employee/profile",
            method: "POST",
            data: token.username
        }).then((res={}) => {
            if (res.status === 1) {
                if (res.response.result !== undefined) {
                    const data = res.response.result || {};
                    this.setState({ adminlist: data });
                    if (data) {
                        const num = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
                        let timeoffdata;
                        this.setState({
                            id: data._id,
                            username: data.username,
                            name: data.name,
                            email: data.email,
                            job_type: data.job_type,
                            locations: data.locations,
                            status: data.status,
                            number: data.phone && data.phone.number,
                            dailcountry: data.phone ? data.phone.dailcountry : "gb",
                            code: data.phone && data.phone.code,
                            line1: data.address && data.address.line1,
                            line2: data.address && data.address.line2,
                            city: data.address && data.address.city,
                            state: data.address && data.address.state,
                            country: data.address && data.address.country,
                            zipcode: data.address && data.address.zipcode,
                            lat: data.address && data.address.lat,
                            lon: data.address && data.address.lon,
                            formatted_address: data.address && data.address.formatted_address,
                            avatar_return: data.avatar,
                            avatar: data && data.onlineform && data.onlineform.UploadIDPhoto,
                            form_status: data && data.onlineform && data.onlineform.form_status,
                            timeoffdata
                        });
                        localStorage.setItem('avatar', data && data.onlineform && data.onlineform.UploadIDPhoto);
                    }
                }
            }
        });
    }

    componentWillUnmount = () => {
        clearInterval(this.call_timer1);
        clearInterval(this.call_timer2);
    }
    onChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleChange = address => {
        this.setState({ formatted_address: address });
        this.setState({ address });
    };

    handleSelect = address => {
        this.setState({ address: address });
        this.setState({ formatted_address: address });
        geocodeByAddress(address)
            .then(results => {
                const res_addressmap_strt_no = results[0].address_components.find(item => {
                    return item.types[0] === "street_number";
                });
                this.setState({
                    line1: res_addressmap_strt_no && res_addressmap_strt_no.long_name
                });
                const res_addressmap_route = results[0].address_components.find(item => {
                    return item.types[0] === "route";
                });
                this.setState({
                    line2: res_addressmap_route && res_addressmap_route.long_name
                });
                const res_addressmap_postalTown = results[0].address_components.find(item => {
                    return item.types[0] === "postal_town";
                });
                this.setState({
                    city: res_addressmap_postalTown && res_addressmap_postalTown.long_name
                });
                const res_addressmap_adLvl1 = results[0].address_components.find(item => {
                    return item.types[0] === "administrative_area_level_1";
                });
                this.setState({
                    state: res_addressmap_adLvl1 && res_addressmap_adLvl1.long_name
                });
                const res_addressmap_country = results[0].address_components.find(item => {
                    return item.types[0] === "country";
                });
                this.setState({
                    country: res_addressmap_country && res_addressmap_country.long_name
                });
                const res_addressmap_zip = results[0].address_components.find(item => {
                    return item.types[0] === "postal_code";
                });
                this.setState({
                    zipcode: res_addressmap_zip && res_addressmap_zip.long_name
                });
                getLatLng(results[0]).then(latlong => {
                    this.setState({ lat: latlong.lat });
                    this.setState({ lon: latlong.lng });
                });
            })
            .catch(error => console.error("Error", error));
    };

    handler = (status, value, countryData, number, id) => {
        if (status === true) {
            this.setState({
                phoneerror: false
            });
        } else {
            this.setState({
                phoneerror: true
            });
        }
        this.setState({
            number: value,
            code: countryData.dialCode,
            dailcountry: countryData.iso2,
            phonestatus: status
        });
    };
    phonefield = value => {
        if (value === "") {
            this.setState({
                phoneerror: true
            });
        }
    };

    fileChangedHandler = evt => {
        this.setState({
            avatar: evt.target.files[0],
            avatarName: evt.target.files[0].name
        });
    };

    locationsselect = value => {
        if (value) {
            this.setState({ locations: value });
        }
    };
    jobtypeselect = value => {
        if (value) {
            this.setState({ job_type: value });
        }
    };

    onCrop = propreview => {
        function base64ImageToBlob(propreview) {
            const pos = propreview.indexOf(";base64,");
            const type = propreview.substring(5, pos);
            const b64 = propreview.substr(pos + 8);
            const imageContent = atob(b64);
            const buffer = new ArrayBuffer(imageContent.length);
            const view = new Uint8Array(buffer);
            for (let n = 0; n < imageContent.length; n++) {
                view[n] = imageContent.charCodeAt(n);
            }
            const blob = new Blob([buffer], { type: type });
            return blob;
        }
        const dataURItoBlob = base64ImageToBlob(propreview);
        this.setState({ propreview, avatar: dataURItoBlob });
    };

    readUrl = (pictureFiles, pictureDataURLs) => {
        if (pictureFiles.length === 0)
            return;
        var mimeType = pictureFiles[0].type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        var reader = new FileReader();
        reader.readAsDataURL(pictureFiles[0]);
        reader.onload = (_event) => {
            this.setState({
                url: reader.result,
                avatar: pictureFiles[0],
            })
        }
    }

    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    OnFormSubmit = (e, values) => {
        e.persist();
        if (this.state.phonestatus === false || this.state.number === "") {
            this.setState({
                phoneerror: true
            });
            toast.error("Enter Phone Number");
        } else {
            const data = new FormData();
            data.append("_id", this.state.id);
            data.append("username", this.state.username);
            if (this.state.password !== "") {
                data.append("password", this.state.password);
            }
            if (this.state.confirm_password !== "") {
                data.append("confirm_password", this.state.confirm_password);
            }
            data.append("name", this.state.name);
            data.append("email", this.state.email);
            data.append("avatar", this.state.avatar);
            data.append("phone[code]", this.state.code);
            data.append("phone[number]", this.state.number);
            data.append("phone[dailcountry]", this.state.dailcountry || "gb");
            data.append("address[line1]", this.state.line1);
            data.append("address[line2]", this.state.line2);
            data.append("address[city]", this.state.city);
            data.append("address[state]", this.state.state);
            data.append("address[country]", this.state.country);
            data.append("address[zipcode]", this.state.zipcode);
            data.append("address[formatted_address]", this.state.formatted_address);
            data.append("address[lat]", this.state.lat);
            data.append("address[lon]", this.state.lon);
            data.append("status", this.state.status);
            data.append("_id", this.state.id);
            request({
                url: "/employee/edit/profile/save",
                method: "POST",
                data: data
            }).then(res => {
                if (res.status === 1) {
                    let toastId = "profileEditSaved";
                    if (!toast.isActive(toastId)) {
                        toastId = toast.success("Updated");
                    }
                    this.componentDidMount();
                } else if (res.status === 0) {
                    let toastId = "profileEditResponse";
                    if (!toast.isActive(toastId)) {
                        toastId = toast.error(res.response);
                    }
                }
            }).catch(error => {
                let toastId = "profileEditError";
                if (!toast.isActive(toastId)) {
                    toastId = toast.error(error);
                }
            });
        }
    };

    render() {
        const highl = this.state.timeoffdata && this.state.timeoffdata.map(list => new Date(list.dates));
        const modifiers = {
            highlighted: highl
        };
        const { form_status } = this.state || {};
        const { avatar, url, int } = this.state;
        return (
            <Fragment>
                <Breadcrumb parent="Profile" title="Edit Profile" />
                {int ? <CandidateStats /> : null}
                <div className="container-fluid">

                        <div className="admin-headers-main margin-top-box">
                            <span className="heading-text">
                            <img src={admin_heading} alt="admin" />
                            <span class="main-headings">Edit Profile</span>
                            </span>
                        </div>

                                <AvForm className="card" noValidate="" onValidSubmit={this.OnFormSubmit}>
                                    <div className="card-body">
                                        <div className="row">
                                        <Col xs="12" md="12">
                                            <div className="cus-design edited-section add-border">
                                            <div className="admin-spaces">
                                            <Col xs="12" md="12">
                                                <p className="basic-headings">Basic Details</p>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <AvGroup className="form-group">
                                                    <Label>Username</Label>
                                                    <AvInput className="form-control fname disable-inputs" type="text" name="username" placeholder="Enter Username" onChange={this.onChange} value={this.state.username} disabled autoComplete="name" />
                                                    <AvFeedback>User Name is required!</AvFeedback>
                                                </AvGroup>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <AvGroup>
                                                    <Label>First Name</Label>
                                                    <AvInput type="text" name="name" placeholder="Enter Name" onChange={this.onChange} value={this.state.name} required />
                                                    <AvFeedback>First Name is required!</AvFeedback>
                                                </AvGroup>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <div className="form-group position-relative form-group">
                                                    <Label>Phone</Label>
                                                    {this.state && this.state.dailcountry ? (
                                                        <IntlTelInput
                                                            placeholder=""
                                                            style={{ width: "100%" }}
                                                            defaultCountry={this.state.dailcountry}
                                                            utilsScript={libphonenumber}
                                                            css={["intl-tel-input", "form-control"]}
                                                            onPhoneNumberChange={this.handler}
                                                            value={this.state.number}
                                                        />
                                                    ) : null}
                                                    {this.state.phoneerror ? <div style={{ color: "red" }}> Enter Valid Phone Number!</div> : null}
                                                </div>
                                            </Col>

                                            <Col xs="12" md="4">
                                                <AvGroup className="form-group left">
                                                    <Label>Email Address</Label>
                                                    <AvInput className="form-control fname disable-inputs" name="email" type="email" placeholder="Enter Email Address" disabled onChange={this.onChange} value={this.state.email} autoComplete="email" required />
                                                    <AvFeedback>This is required!</AvFeedback>
                                                </AvGroup>
                                            </Col>
                                            </div>
                                            <div className="admin-spaces border-ranss ">
                                            <Col xs="12" md="12">
                                                <p className="basic-headings" >Login Details</p>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <AvGroup className="form-group left">
                                                    <Label>Password</Label>
                                                    <AvInput className="form-control fname" type="password" name="password" placeholder="Enter Password" onChange={this.onChange} value={this.state.password} autoComplete="off" />
                                                </AvGroup>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <AvGroup className="form-group left">
                                                    <Label>Confirm Password</Label>
                                                    <AvInput
                                                        className="form-control fname"
                                                        type="password"
                                                        name="confirm_password"
                                                        placeholder="Re-Enter Password"
                                                        onChange={this.onChange}
                                                        value={this.state.confirm_password}
                                                        validate={{ match: { value: "password" } }}
                                                        autoComplete="off"
                                                    />
                                                    <AvFeedback>Match Password!</AvFeedback>
                                                </AvGroup>
                                            </Col>
                                            {/*<div className="col-sm-12 col-md-12" align="center">
                                                <img className="rounded-circle img-100" src={avatar === "" || url ? url ? url : user : NodeURL + "/" + avatar} alt="" />
                                                <div className="icon-wrapper">
                                                    <ImageUploader
                                                        withIcon={false}
                                                        withPreview={false}
                                                        label=""
                                                        singleImage={true}
                                                        buttonText="Upload Profile"
                                                        onChange={this.readUrl}
                                                        imgExtension={[".jpg", ".png"]}
                                                        maxFileSize={1048576}
                                                        fileSizeError=" file size is too big"
                                                    />
                                                </div>
                                            </div>*/}
                                            </div>

                                            <div className="admin-spaces border-ranss ">
                                            <Col xs="12" md="12">
                                                <p className="basic-headings">Address Details</p>
                                            </Col>
                                            
                                                <Col xs="12" md="4">
                                                        <div className="form-group position-relative form-group width-input">
                                                            <Label>Search address</Label>
                                                            <PlacesAutocomplete value={this.state.formatted_address} onChange={this.handleChange} onSelect={this.handleSelect} onFocus={this.geolocate}
                                                            >
                                                                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                                                                    <div>
                                                                        <input
                                                                            {...getInputProps({
                                                                                placeholder: "Search Places",
                                                                                className: "form-control serach-place"
                                                                            })}
                                                                        />
                                                                        <div className="autocomplete-dropdown-container absolute">
                                                                            {suggestions.map(suggestion => {
                                                                                const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
                                                                                // inline style for demonstration purpose
                                                                                const style = suggestion.active
                                                                                    ? {
                                                                                        backgroundColor: "#fafafa",
                                                                                        cursor: "pointer"
                                                                                    }
                                                                                    : {
                                                                                        backgroundColor: "#ffffff",
                                                                                        cursor: "pointer"
                                                                                    };
                                                                                return (
                                                                                    <div
                                                                                        {...getSuggestionItemProps(suggestion, {
                                                                                            className,
                                                                                            style
                                                                                        })}
                                                                                    >
                                                                                        <span>{suggestion.description}</span>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </PlacesAutocomplete>
                                                        </div>
                                                </Col>

                                                <Col xs="12" md="4">
                                                    <div className="edit-changes">
                                                        <AvGroup className="form-group left">
                                                            <Label>Line1</Label>
                                                            <AvInput className="form-control fname disable-inputs" type="text" name="line1" placeholder="Enter Line1" onChange={this.onChange} value={this.state.line1} required disabled autoComplete="name" />
                                                            <AvFeedback>This is required!</AvFeedback>
                                                        </AvGroup>
                                                    </div>
                                                </Col>
                                                <Col xs="12" md="4">
                                                    <div className="edit-changes">
                                                        <AvGroup className="form-group left">
                                                            <Label>Line2</Label>
                                                            <AvInput className="form-control fname disable-inputs" type="text" name="line2" placeholder="Enter Line1" onChange={this.onChange} value={this.state.line2} required disabled autoComplete="name" />
                                                            <AvFeedback>This is required!</AvFeedback>
                                                        </AvGroup>
                                                    </div>
                                                </Col>
                                                <Col xs="12" md="4">
                                                    <div className="edit-changes">
                                                        <AvGroup className="form-group left">
                                                            <Label>Country</Label>
                                                            <AvInput className="form-control fname disable-inputs" type="text" name="country" placeholder="Enter Country" onChange={this.onChange} value={this.state.country} required disabled autoComplete="name" />
                                                            <AvFeedback>This is required!</AvFeedback>
                                                        </AvGroup>
                                                    </div>
                                                </Col>
                                                <Col xs="12" md="4">
                                                    <div className="edit-changes">
                                                        <AvGroup className="form-group left">
                                                            <Label>Postal Code</Label>
                                                            <AvInput className="form-control fname disable-inputs" type="text" name="zipcode" placeholder="Enter Zipcode" onChange={this.onChange} value={this.state.zipcode} required disabled autoComplete="name" />
                                                            <AvFeedback>This is required!</AvFeedback>
                                                        </AvGroup>
                                                    </div>
                                                </Col>
                                                <Col xs="12" md="4">
                                                    <div className="edit-changes">
                                                        <AvGroup className="form-group left">
                                                            <Label>City/Town</Label>
                                                            <AvInput className="form-control fname disable-inputs" type="text" name="city" placeholder="Enter City/Town" onChange={this.onChange} value={this.state.city} required disabled autoComplete="name" />
                                                            <AvFeedback>This is required!</AvFeedback>
                                                        </AvGroup>
                                                    </div>
                                                </Col>
                                                <Col xs="12" md="4">
                                                    <div className="edit-changes">
                                                        <AvGroup className="form-group left">
                                                            <Label>State/Region</Label>
                                                            <AvInput className="form-control fname disable-inputs" type="text" name="state" placeholder="Enter State " onChange={this.onChange} value={this.state.state} required disabled autoComplete="name" />
                                                            <AvFeedback>This is required!</AvFeedback>
                                                        </AvGroup>
                                                    </div>
                                                </Col>
                                                </div>
                                               
                                               </div>
                                               </Col>
                                            </div>
                                            </div>
                                            
                                    <div className="card-footer text-right">
                                        <button className="btn btn-primary" type="submit">Save Profile</button>
                                    </div>

                                </AvForm>
                </div>
            </Fragment>
        )


    }
};
export default EDITPROFILE;